import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';
import { getCountryName } from '../../translations/countryCodes';
import { allUnitOptions } from '../../config/configMeasurement';

import css from './ListingPage.module.css';

const SectionShippingInformation = props => {
  const { publicData, intl } = props;

  if (!publicData) {
    return null;
  }

  const {
    shipping = [],
    boxDimensions,
    shippingWeight,
    shippingWeightUnit,
    everywhereElse,
  } = publicData;

  let specificLocations = [];
  if (everywhereElse) {
    specificLocations.push(
      intl.formatMessage({
        id: 'SectionShippingInformation.everywhere',
      })
    );
  } else {
    specificLocations = [...specificLocations, ...shipping.map(item => {
      const countryName = getCountryName(item.country);
      const shippingState = item.state ? ` - ${item.state}` : '';
      const shippingPostalCode = item.postalCode ? ` - ${item.postalCode}` : '';
      return `${countryName}${shippingState}${shippingPostalCode}`;
    })];
  }

  return (
    <div className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="SectionShippingInformation.shippingInformationTitle" />
      </Heading>
      <ul className={css.details}>
        {specificLocations.map((detail, index) => (
          <li key={detail} className={css.detailsRow}>
            {index === 0 ? (
              <span className={css.detailLabel}>
                {intl.formatMessage({
                  id: 'SectionShippingInformation.shippingZone',
                })}
              </span>
            ) : (
              <div />
            )}
            <span>{detail}</span>
          </li>
        ))}
        {shippingWeight && (
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>
              {intl.formatMessage({
                id: 'SectionShippingInformation.shippingWeight',
              })}
            </span>
            <span>{shippingWeight}</span>
          </li>
        )}
        {shippingWeightUnit && (
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>
              {intl.formatMessage({
                id: 'SectionShippingInformation.shippingWeightUnit',
              })}
            </span>
            <span>
              {allUnitOptions.find(item => item.key === shippingWeightUnit)?.label || shippingWeightUnit}
            </span>
          </li>
        )}
        {boxDimensions && (
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>
              {intl.formatMessage({
                id: 'SectionShippingInformation.boxDimensions',
              })}
            </span>
            <span>{boxDimensions}</span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default SectionShippingInformation;
